module.exports = __webpack_public_path__ + "static/media/Y.ae635cf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/Y.jpg
// module id = 93
// module chunks = 0